import { LabelWithTooltip } from '@hub/features/account-dashboard/components/label-with-tooltip';
import { DashboardCard, Typography } from '@monorepo/nova-ui';
import { StatisticCardProps } from '../statistics-grid';

export const StatisticCard = ({
  label,
  tooltip,
  value,
}: StatisticCardProps) => {
  return (
    <DashboardCard
      sx={(theme) => ({
        flexDirection: 'column',
        flex: 1,
        minWidth: theme.breakpoints.up('sm') ? theme.spacing(40) : '100%',
      })}
    >
      <LabelWithTooltip label={label} tooltip={tooltip} />
      <Typography
        variant="h5"
        sx={(theme) => ({
          fontSize: theme.typography.pxToRem(22),
          fontWeight: theme.typography.fontWeightMedium,
          marginTop: theme.spacing(3),
        })}
      >
        {value}
      </Typography>
    </DashboardCard>
  );
};
